<div class="modal-header">
  <h4 class="modal-title">Remove Customer from Follow-Up</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onCancel()"></button>
</div>

<div class="modal-body">
  <label for="reason"><b>Removal Reason Note</b>&nbsp;<span class="required">*</span></label>
  <textarea
    id="reason"
    class="form-control"
    rows="4"
    [(ngModel)]="reason"
    placeholder="Enter the reason the customer should be removed from follow-up contact list">
  </textarea>
</div>

<div class="modal-footer">
  <button
    type="button"
    class="btn btn-primary"
    [disabled]="!isValid"
    (click)="onConfirm()">
    Save
  </button>
</div>
